<template>
    <div class="sample_home">
        <div class="sample1">
            <div class="sample1_cont">
                <p class="p1">定制课程</p>
                <p class="p2">作品集课程</p>
                <p class="p3">RoSSo专业服务近十年，累计圆梦学生16000+</p>
            </div>
        </div>
        <div class="sample2">
            <div class="sample2_cont">
                作品集课程包含从前期的灵感来源/调研/实验/分析/制作过程/摄影排版多个项目。作品集是个人专业能力和综合能力的缩影，是一个学生表达个人兴趣喜好的一种艺术媒介。通常情况下作品集由4-6个项目组成，RoSSo会根据学生申请的学位、国家的偏好、院校的类型，针对性的去辅导。
                <br>
                <span>适合人群：</span>申请艺术设计院校本科、研究生的学生 <br>
                <span>师资力量：</span>海归艺术家导师+TOP艺术院校教授 <br>
                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                <div>
                    <p>立即咨询</p>
                    <img src="../img/vip院校计划/Group 703.png" alt="">
                </div>
            </a>
            </div>
        </div>
        <div class="sample3">
            <div class="title_box">
                <div class="title_cn">各国家艺术院校申请作品集特点</div>
                <div class="title_en">PORTFOLIO FEATURES OF DIFFERENT REGIONS</div>
            </div>
            <div class="sample3_cont">
                <div class="swiper mySwiperSa1">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="sample3_item">
                                <div class="p1">
                                    <img src="../img/作品集/11.png" alt="">
                                    <p>英国</p>
                                </div>
                                <p class="p2">ENGLAND</p>
                                <p class="p3">
                                    <span>特点：</span>注重基础和理论，要能够体现项目的灵感来源、构思过程、创作细节、要兼顾研究性、艺术性和原创性 <br><br>
                                    <span>优势专业：</span>室内设计、工业设计、珠宝设计、电影、服装设计、建筑景观设计
                                </p>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="sample3_item">
                                <div class="p1">
                                    <img src="../img/作品集/22.png" alt="">
                                    <p>加拿大</p>
                                </div>
                                <p class="p2">CANADA</p>
                                <p class="p3">
                                    <span>特点：</span>加拿大多元文化融合，要求上也是自由而包容的，希望学生更多的尝试不同的艺术形式，去展现独特的个性和想法 <br><br>
                                    <span>优势专业：</span>动画、平面设计、纯艺术、插画、工业设计、游戏
                                </p>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="sample3_item">
                                <div class="p1">
                                    <img src="../img/作品集/33.png" alt="">
                                    <p>美国</p>
                                </div>
                                <p class="p2">AMERICA</p>
                                <p class="p3">
                                    <span>特点：</span>着重考察申请者是否有独创性、可塑性，喜欢自主创新、具有原创性和多元化的作品，作品集表演力要强，风格突出，有延续性。 <br><br>
                                    <span>优势专业：</span>视觉设计、工业设计、媒体艺术、电影、摄影、纯艺术、数码艺术设计
                                </p>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="sample3_item">
                                <div class="p1">
                                    <img src="../img/作品集/44.png" alt="">
                                    <p>法国</p>
                                </div>
                                <p class="p2">FRANCE</p>
                                <p class="p3">
                                    <span>特点：</span>法国传统艺术气息浓厚，偏重于创造性的思维，看重学生的创新性，考究专业基本功，更多挖掘学生的个人特色和潜能 <br><br>
                                    <span>优势专业：</span>服装设计、空间设计、纯艺术专业
                                </p>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="sample3_item">
                                <div class="p1">
                                    <img src="../img/作品集/55.png" alt="">
                                    <p>意大利</p>
                                </div>
                                <p class="p2">ITALY</p>
                                <p class="p3">
                                    <span>特点：</span>强调学生要有自己独特的想法和优秀的专业功底，学生通过作品充分展现个人的兴趣偏好，有明确的风格和个性 <br><br>
                                    <span>优势专业：</span>动画、平面设计、建筑景观设计
                                </p>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="sample3_item">
                                <div class="p1">
                                    <img src="../img/作品集/66.png" alt="">
                                    <p>日本</p>
                                </div>
                                <p class="p2">JAPAN</p>
                                <p class="p3">
                                    <span>特点：</span>日本艺术设计审美风格独特，属于简单实用、兼收并蓄的多元化艺术设计风格，偏重于创造性的思维，希望学生用多样的材料去尝试，发散思维 <br><br>
                                    <span>优势专业：</span>动画、平面设计、插画、产品设计、纯艺术
                                </p>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="sample3_item">
                                <div class="p1">
                                    <img src="../img/作品集/77.png" alt="">
                                    <p>澳大利亚 </p>
                                </div>
                                <p class="p2">AUSTRALIA</p>
                                <p class="p3">
                                    <span>特点：</span>丰富的移民文化及艺术氛围，使澳大利亚的艺术设计作品更具现代感。澳洲偏重于创造性的思维，希望学生用多样的材料去尝试，发散思维。 <br><br>
                                    <span>优势专业：</span>动画、平面设计、建筑景观设计
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
        <div class="sample4">
            <div class="title_box">
                <div class="title_cn">RoSSo的服务流程</div>
                <div class="title_en">RoSSo SERVICE PROCESS</div>
            </div>
            <img src="../img/作品集/3.png" alt="">
        </div>

        <img src="../img/作品集/4.jpg" alt="" class="sample5">

        <div class="courses4">
            <div class="section_box">
                <div class="section_title_cn">RoSSo独特四步教学法</div>
                <div class="section_title_en">RoSSo METHODS</div>
            </div>
            <div class="c4_cont">
                <div class="c4_item">
                    <div class="c4_left">
                        <div>LEVEL 1：</div>
                        <div>Universal</div>
                        <div>Cornerstones of Art</div>
                    </div>
                    <div class="c4_mid">1</div>
                    <div class="c4_right">
                        <div>艺术启发</div>
                        <div>基础先修课程</div>
                    </div>
                </div>
                <div class="c4_item">
                    <div class="c4_left c4_left2">
                        <div>LEVEL 2：</div>
                        <div>Research and</div>
                        <div>Technique Exploration</div>
                    </div>
                    <div class="c4_mid">2</div>
                    <div class="c4_right">
                        <div>艺术探索</div>
                        <div>理论实践课程</div>
                    </div>
                </div>
                <div class="c4_item">
                    <div class="c4_left c4_left3">
                        <div>LEVEL3：</div>
                        <div>Art and Design</div>
                        <div>Project Establishment</div>
                    </div>
                    <div class="c4_mid">3</div>
                    <div class="c4_right">
                        <div>艺术设计</div>
                        <div>项目核心课程</div>
                    </div>
                </div>
                <div class="c4_item">
                    <div class="c4_left c4_left4">
                        <div>LEVEL 4：</div>
                        <div>Art and Design</div>
                        <div>Project Specialization</div>
                    </div>
                    <div class="c4_mid">4</div>
                    <div class="c4_right">
                        <div>艺术设计</div>
                        <div>项目进阶课程</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="courses5">
            <div class="section_box">
                <div class="section_title_cn">多重五维RoSSo审核体系</div>
                <div class="section_title_en">COMPREHENSIVE AUDIT SYSTEM</div>
            </div>
            <div class="c5_cont">
                <div class="swiper mySwiperC2">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="c5_item">
                                <div class="c5_left">
                                    <h1>1.专业审核 （初级考核）</h1>
                                    <p>主线导师指导下定制教学大纲。专业导师对每次课程作业和项目产出进行审核与把控</p>
                                </div>
                                <img src="../img/艺术课程/Rectangle 493.jpg" alt="">
                            </div>
                            <div class="c5_item">
                                <div class="c5_left">
                                    <h1>2.阶段性考核（期中考核）</h1>
                                    <p>还原海外授课模式，每2/3个月进行阶段性critique审核，训练学生面试的逻辑感和表达能力。</p>
                                </div>
                                <img src="../img/艺术课程/Rectangle 495.jpg" alt="">
                            </div>
                            <div class="c5_item">
                                <div class="c5_left">
                                    <h1>3.进阶项目提升</h1>
                                    <p>所属科系主管组织多名导师对学员产出进度和发展方向进行科系内审与评估，助力学员在后半程进阶提升；</p>
                                </div>
                                <img src="../img/艺术课程/Rectangle 496.jpg" alt="">
                            </div>

                        </div>
                        <div class="swiper-slide">
                            <div class="c5_item">
                                <div class="c5_left">
                                    <h1>4. 教研终审</h1>
                                    <p>全国教研组对学员每个项目进行审核，采用海外名校考核维度与RoSSo多年教学经验相结合，提供更专业和客观的建议，严格把控作品质量；</p>
                                </div>
                                <img src="../img/艺术课程/Rectangle 498.jpg" alt="">
                            </div>
                            <div class="c5_item">
                                <div class="c5_left">
                                    <h1>5.名校教授审核</h1>
                                    <p>海外教授以真实的海外名校教学和审核体制为蓝本，对学员作品进行全面审核与评估，从经验和权威性等方面助力学员提升申请成功率。</p>
                                </div>
                                <img src="../img/艺术课程/Rectangle 499.jpg" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>

        <div class="v3">
            <div class="v3_cont">

                <div class="swiper mySwiperV3">
                    <div class="v3_title">
                        <p>国际师资团队 >></p>
                        <div class="v3_btn" @click="toggleV3(0)">#海外教授</div>
                        <div class="v3_btn" @click="toggleV3(1)">#海归导师</div>
                    </div>
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in teacherData">
                            <div class="v3_item" v-for="(item2, index2) in item" @click="teacherDetail(item2.id)">
                                <div class="img_box">
                                    <img :src="'https://public.rossoarts.com/static/uploads/teacher/' + item2.avatar"
                                        alt="">
                                </div>
                                <span class="p1">{{ item2.school | schoolAll }}</span>
                                <h2>{{ item2.name | fliterName }}</h2>
                                <p class="p2">{{ item2.major }}</p>
                                <p class="p3">{{ item2.school | schoolSplit }}</p>
                            </div>

                        </div>

                    </div>
                    <div class="swiper-pagination"></div>
                    <!-- <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div> -->
                </div>

            </div>

        </div>

        <div class="v4">
            <div class="v3_cont v4_cont">
                <div class="v3_title">
                        <p>最新录取案例 >></p>
                        <div>#2023年</div>

                    </div>
                <div class="swiper mySwiperV1">

                   
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="v4_item">
                                <img src="../img/vip院校计划/1.jpg" alt="" class="larger_img" @click="imgCover($event)">
                            </div>
                            <div class="v4_item">
                                <img src="../img/vip院校计划/2.jpg" alt="" class="larger_img" @click="imgCover($event)">
                            </div>
                            <div class="v4_item">
                                <img src="../img/vip院校计划/3.jpg" alt="" class="larger_img" @click="imgCover($event)">
                            </div>
                            <div class="v4_item">
                                <img src="../img/vip院校计划/4.jpg" alt="" class="larger_img" @click="imgCover($event)">
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="v4_item">
                                <img src="../img/vip院校计划/5.jpg" alt="" class="larger_img" @click="imgCover($event)">
                            </div>
                            <div class="v4_item">
                                <img src="../img/vip院校计划/6.jpg" alt="" class="larger_img" @click="imgCover($event)">
                            </div>
                            <div class="v4_item">
                                <img src="../img/vip院校计划/7.jpg" alt="" class="larger_img" @click="imgCover($event)">
                            </div>
                            <div class="v4_item">
                                <img src="../img/vip院校计划/8.jpg" alt="" class="larger_img" @click="imgCover($event)">
                            </div>
                        </div>


                    </div>
                    <div class="swiper-pagination"></div>
                    <!-- <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div> -->
                </div>

            </div>

        </div>

        <div class="section_inp">
            <div class="s_inp_left">
                <img src="../img/Group 302.png" alt="" class="img_shou" id="imgText">
            </div>
            <div class="s_inp_right">
                <el-form :inline="true" :label-position="labelPosition" label-width="1.2rem" :model="formLabelAlign"
                    style="justify-content: center;">
                    <el-form-item label="姓名：">
                        <el-input v-model="formLabelAlign.name" placeholder="输入姓名"></el-input>
                    </el-form-item>

                    <el-form-item label="意向专业：">
                        <el-input v-model="formLabelAlign.major" placeholder="意向专业"></el-input>
                    </el-form-item>
                    <el-form-item label="电话：">
                        <el-input v-model="formLabelAlign.tel" placeholder="输入电话号"></el-input>
                    </el-form-item>
                    <el-form-item label="意向国家：" class="elitem2">
                        <el-select v-model="formLabelAlign.region2" placeholder="国家">
                            <el-option label="英国" value="England"></el-option>
                            <el-option label="美国" value="America"></el-option>
                            <el-option label="日本" value="Japan"></el-option>
                            <el-option label="新加坡" value="Singapore"></el-option>
                            <el-option label="韩国" value="Korea"></el-option>
                            <el-option label="欧洲" value="Europe"></el-option>
                           
                            <el-option label="其他" value="Other"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div class="yuyue" @click="onSubmit()"></div>
                    </el-form-item>
                </el-form>
            </div>

        </div>
    </div>
</template>
<script>
var _self
import "@/assets/css/sample.css"
import axios from "axios"
import Swiper from 'swiper/bundle'
// import  Swiper from 'swiper/vue';
import 'swiper/css';
import "swiper/css/effect-cards";
import 'swiper/css/pagination';
import 'swiper/css/navigation';
export default {
    data() {
        return {
            category: 2,
            teacherData:[],
            labelPosition: 'right',
            formLabelAlign: {
                name: '',
                tel: '',
                region: '',
                region2: '',
                budget: '',
            },
        }
    },
    filters: {
        fliterName(val) {
            // console.log(val, _self.category);
            return _self.category == 1 ? val : "Prof." + val
        },
        schoolAll(val) {
            return val.split(",")[1]
        },
        schoolSplit(val) {
            return val.split(",")[0]
        },
    },
    beforeCreate() {
        _self = this;
    },
    created() {
        this.getTeacherData()
    },
    methods: {
        teacherDetail(val){
            this.$router.push(`/teachers/${val}.html`)
        },
        onSubmit() {
            var currentURL = window.location.href;
            var status = ''
            // 检查 URL 中是否包含某些关键词，来判断使用的搜索引擎
            if (currentURL.includes("google.com")) {
                status = "用户正在使用 Google 搜索引擎"
            } else if (currentURL.includes("bing.com")) {
                status = "用户正在使用 Bing 搜索引擎"
            } else if (currentURL.includes("yahoo.com")) {
                status = "用户正在使用 Yahoo 搜索引擎"
            } else if (currentURL.includes("baidu.com")) {
                status = "用户正在使用 百度 搜索引擎"
            } else {
                status = "无法确定用户使用的搜索引擎"
            }
            var patt = /^1[3-9][0-9]{9}$/
            if (this.formLabelAlign.name == "" || this.formLabelAlign.tel == "") {
                // console.log("姓名和手机号不能为空");
                this.$message.error('姓名和手机号不能为空');
            } else {
                // console.log("不是空");
                if (patt.test(this.formLabelAlign.tel)) {
                    // console.log("可以发请求");
                    // console.log(this.formInline);
                    axios.post("https://public.rossoarts.com/index/common/getform", {
                        "name": this.formLabelAlign.name,
                        "tel": this.formLabelAlign.tel,
                        "major": this.formLabelAlign.major,
                        "intended_country":this.formLabelAlign.region2,
                        "url": window.location.href,
                        "status":status,
                    }).then((data) => {
                        console.log(data, "response");
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error, "error");
                    });
                } else {
                    console.log("手机号格式不正确");
                    this.$message.error('手机号格式不正确');
                }
            }
        },
        toggleV3(val) {
            // console.log(val);
            var v3_btn = document.getElementsByClassName("v3_btn")
            for (var i = 0; i < v3_btn.length; i++) {
                v3_btn[i].style.color = "#000"
                v3_btn[i].style.borderColor = "#000"
            }
            v3_btn[val].style.color = "#FB6333"
            v3_btn[val].style.borderColor = "#FB6333"
            if (val == 0) {
                this.category = 2
            } else {
                this.category = 1
            }
            this.getTeacherData()
        },
        arrGroup(array, sublength) {
            let index = 0;
            let newArray = []
            while (index < array.length) {
                newArray.push(array.slice(index, index += sublength))
            }
            return newArray
        },
        getTeacherData() {
            axios.get(`https://public.rossoarts.com/api/v1/getFirstTeacher?category=${this.category}&limit=12`).then((data) => {
                // console.log(data.data);
                this.teacherData = this.arrGroup(data.data, 4)
                // console.log(this.teacherData);
                this.$nextTick(() => {
                    this.mySwiperV3Init()
                })
            })
        },
        mySwiperV1Init() {
            new Swiper('.mySwiperV1', {
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },

            })
        },
        mySwiperV3Init() {
            new Swiper('.mySwiperV3', {
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },

            })
        },
    },
    mounted() {
        var swiper = new Swiper(".mySwiperSa1", {
            loop: true,
            pagination: {
                clickable: true,
                el: ".swiper-pagination",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
        var swiper = new Swiper(".mySwiperC2", {
            // slidesPerView: 3,
            // spaceBetween: 30,
            // effect:'cube', 
            loop: true,

            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
        this.mySwiperV1Init()
    }
}
</script>